var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F38E74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 19.9999C17.5213 19.9999 19.4 18.1212 19.4 15.7999C19.4 13.4787 17.5213 11.5999 15.2 11.5999C12.8788 11.5999 11 13.4787 11 15.7999C11 18.1212 12.8788 19.9999 15.2 19.9999ZM18.08 21.1999H17.7688C16.9888 21.5749 16.1225 21.7999 15.2 21.7999C14.2775 21.7999 13.415 21.5749 12.6313 21.1999H12.32C9.935 21.1999 8 23.1349 8 25.5199V26.5999C8 27.5937 8.80625 28.3999 9.8 28.3999H20.6C21.5938 28.3999 22.4 27.5937 22.4 26.5999V25.5199C22.4 23.1349 20.465 21.1999 18.08 21.1999ZM26 19.9999C27.9875 19.9999 29.6 18.3874 29.6 16.3999C29.6 14.4124 27.9875 12.7999 26 12.7999C24.0125 12.7999 22.4 14.4124 22.4 16.3999C22.4 18.3874 24.0125 19.9999 26 19.9999ZM27.8 21.1999H27.6575C27.1363 21.3799 26.585 21.4999 26 21.4999C25.415 21.4999 24.8638 21.3799 24.3425 21.1999H24.2C23.435 21.1999 22.73 21.4212 22.1112 21.7774C23.0262 22.7637 23.6 24.0724 23.6 25.5199V26.9599C23.6 27.0424 23.5813 27.1212 23.5775 27.1999H30.2C31.1938 27.1999 32 26.3937 32 25.3999C32 23.0787 30.1213 21.1999 27.8 21.1999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsers);
export default __webpack_public_path__ + "static/media/total-users.5afb68b10d1cd0ade5bf917392ed6a96.svg";
export { ForwardRef as ReactComponent };